<ng-template #DMStrip>
    <div style="display: flex; justify-content: space-between; align-items: center">
        <div style="display: flex; align-items: center">
            <div style="position: relative; margin-right: 10px">
                @if (order.delivery_partner_details.status < 3) {
                    <img src="{{ DEPLOY_URL }}/assets/icons/dm-related/dm_icon.svg" style="width: 40px; height: 40px" />
                }
                @if (order.delivery_partner_details.status > 2) {
                    <img src="{{ DEPLOY_URL }}/assets/icons/dm-related/dm_rating.svg" style="width: 40px; height: 40px" />
                }
                @if (order.delivery_partner_details.status > 2) {
                    <div class="dm-rating">
                        {{ order.delivery_partner_details.delivery_count }}
                    </div>
                }
            </div>
            <div>
                <div style="font-size: 14px; font-weight: bold; line-height: 1.4">
                    {{ order.delivery_partner_details.message.text }}
                </div>
                <div style="font-size: 12px; font-weight: 500; color: #707786; line-height: 1.8">
                    {{ order.delivery_partner_details.message.subtext }}
                </div>
            </div>
        </div>
        @if (order.delivery_partner_details.phone_no) {
            <div (click)="getSupport('Delivery Executive', order.delivery_partner_details.phone_no)">
                <img src="{{ DEPLOY_URL }}/assets/icons/phone-icon.svg" style="width: 40px; height: 40px" />
            </div>
        }
    </div>
</ng-template>

<ng-template #defaultView>
    @if (showDeliveryConfirmation) {
        <ng-container #orderConfirmation>
            <div
                class="common-received {{ wrapperClass }}"
                [ngClass]="{ 'box-shadow': !isMobile && wrapperClass === 'live-tracking' }">
                <div class="text-style2" style="font-size: 14px">Have you received this order?</div>
                <div style="display: flex; justify-content: space-between; height: 36px; margin-top: 10px">
                    <button
                        style="border: 1px solid; width: 48%; border-radius: 4px; font-size: 16px"
                        (click)="setDeliveryConfirmationStatus(false)">
                        NO
                    </button>
                    <button
                        style="color: #fff; background: #0e7c7b; width: 48%; border-radius: 4px; font-size: 16px"
                        (click)="setDeliveryConfirmationStatus(true)">
                        YES
                    </button>
                </div>
            </div>
        </ng-container>
    } @else {
        @if (HelpNSupportText) {
            <div
                class="{{ wrapperClass }}-help"
                [ngStyle]="wrapperClass === 'feedback' ? { 'border-bottom': '10px solid #F2F3F4' } : {}"
                [ngClass]="{ 'box-shadow': !isMobile && wrapperClass === 'live-tracking' }">
                <div style="font-size: 14px; font-weight: bold">{{ HelpNSupportText }}</div>
            </div>
        }
        @if (isMobile && wrapperClass === 'live-tracking' && order.delivery_confirmation.response !== undefined) {
            <div class="divide-strip"></div>
        }
        @if (
            (wrapperClass === 'live-tracking' && order.delivery_partner_details.status) ||
            (wrapperClass !== 'live-tracking' && order.delivery_partner_details.status > 2)
        ) {
            <div
                class="{{ wrapperClass }}-help"
                [ngStyle]="wrapperClass === 'feedback' ? { 'border-bottom': '10px solid #F2F3F4' } : {}"
                [ngClass]="{ 'box-shadow': !isMobile && wrapperClass === 'live-tracking' }">
                <ng-container [ngTemplateOutlet]="DMStrip"></ng-container>
            </div>
        }
        @if (isMobile && wrapperClass === 'live-tracking' && order.delivery_partner_details.status) {
            <div class="divide-strip"></div>
        }
        <div
            class="{{ wrapperClass }}-help"
            [ngStyle]="
                wrapperClass === 'live-tracking' && !isMobile && order.allow_cancellation
                    ? { 'border-radius': '8px 8px 0 0', 'box-shadow': '0 8px 20px #00000012' }
                    : {}
            "
            [ngClass]="{ 'box-shadow': !isMobile && !order.allow_cancellation && wrapperClass === 'live-tracking' }">
            <div style="display: flex; justify-content: space-between">
                <div>
                    <div style="font-size: 14px; font-weight: bold; line-height: 1.8">Need help with your order?</div>
                    <div style="font-size: 12px; font-weight: 500; color: #707786; line-height: 1.8">
                        {{ customer_support_details.label }}
                    </div>
                </div>
                <div style="cursor: pointer">
                    @if (customer_support_details.visibility) {
                        <img src="{{ DEPLOY_URL }}/assets/icons/chat-icon.svg" width="40px" (click)="getSupport('chat')" />
                    }
                    @if (customer_support_details.contact) {
                        <img
                            src="{{ DEPLOY_URL }}/assets/icons/phone-icon.svg"
                            width="40px"
                            style="margin-left: 8px"
                            (click)="getSupport('Customer Support', customer_support_details.contact)" />
                    }
                </div>
            </div>
        </div>
    }
</ng-template>

@if (customer_support_details.visibility || customer_support_details.contact || order.delivery_partner_details.status) {
    <ng-container [ngTemplateOutlet]="defaultView"> </ng-container>
}

<ng-template #contactTemplate let-data>
    <ng-container>
        <mat-icon aria-hidden="true" class="close pull-right" (click)="close()">close</mat-icon>
        <div class="text-style2" style="font-size: 14px; text-transform: uppercase">reach out for help & support</div>
        <div class="help-support">
            <div>
                <img
                    src="{{ DEPLOY_URL }}/assets/icons/help_cc_connect.svg"
                    style="width: 28px; height: 28px; margin-right: 10px" />
                <span style="font-size: 14px">Call {{ data.type }}</span>
                <span style="font-size: 14px"> - {{ data.contact }}</span>
            </div>
        </div>
    </ng-container>
</ng-template>
